/* eslint-disable @typescript-eslint/naming-convention */

import { Partner } from 'src/app/partner/models';

export class StatusEventSubscription {
    SubscriptionsId = 0;
    Name = '';
    IsEnabled = true;
    ArtifactId = '';
    DocumentTypeId = 0;
    PartnerSystemId = 0;
    PartnerInId = 0;
    PartnerOutId = 0;
    StakeholderId = 0;
    StatusNames: string[] = [];
    CreatedDate: Date;
    CreatedBy: number;
    UpdatedDate?: Date;
    UpdatedBy?: number;


    constructor(source?: Partial<StatusEventSubscription>) {
        if (source) {
            Object.assign(this, source);
        }
    }
}

export class StatusEventSubscriptionDisplay extends StatusEventSubscription {
    constructor(source?: Partial<StatusEventSubscriptionDisplay>) {
        super(source);
    }

    PartnerIn: Partner | null = null;
    PartnerOut: Partner | null = null;
}
